<script>
import GanttHeader from '@/components/gantt/GanttHeader.vue';

export default {
  name: 'GanttGrid',
  components: { GanttHeader },
  props: {
    header: Object,
  },
};
</script>

<template lang="pug">

</template>

<style scoped>

</style>
